import { Component } from '@angular/core';
import { NavController, ModalController } from 'ionic-angular';
import { AngularFire } from 'angularfire2';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/observable/range';

import { Article } from '../article/article';

import { Matcher } from '../../utils/matcher';

import moment from 'moment';
//import filter from 'lodash/filter';
import orderBy from 'lodash/orderBy';
import take from 'lodash/take';
import inRange from 'lodash/inRange';

@Component({
  selector: 'page-articles',
  templateUrl: 'articles.html'
})
export class Articles {

  // regex
  pattern = new Matcher();

  subscription: any = null;
  isLoaded: boolean = false;
  articles: Observable<any[]>;
  searchResults: Observable<any[]>;

  constructor(public navCtrl: NavController, 
    public modalCtrl: ModalController,
    public af: AngularFire) {

    this.articles = Observable.combineLatest(
      this.af.database.list('/drafts', {
        query: {
          orderByChild: 'type',
          equalTo: 'article' 
        }
      }),
      this.af.database.list('/posts', {
        query: {
          orderByChild: 'type',
          equalTo: 'article' 
        }
      }),
      (set1, set2) => {
        let list = [];
        set1.map( (item) => { list.push(item); } );
        set2.map( (item) => { list.push(item); } );
        return list;
      }
    );

    this.fetchPage();
  }

  ionViewDidLoad() {

  }

  fetchPage() {
    this.subscription = this.articles.subscribe( (data) => {
      this.isLoaded = true;
      this.getArticles( { target: { value: '*' } } );
    });
  }

  checkTimestamp(ts: number, fromDate: number, toDate?: number) {
    if (!fromDate) {
      return true;
    }

    if (toDate) {
      return inRange(ts, fromDate, toDate);
    } else {
      return inRange(ts, fromDate, moment().unix());
    }
  }

  getArticles(event: any) {
    let val = event.target.value;
    let query: any = this.pattern.match('<value> <from> <to> <order> <limit>', 'string date date order number', val);
    if (!query.value || query.value === '*') {
      query.value = '';
    } else {
      query.value = query.value.toLowerCase();
    }
    console.log('getArticles - query', JSON.stringify(query));

    // this.searchResults = take( orderBy( filter(this.articles, query.value), ['timestamp'], [query.order]), query.limit);
    this.searchResults = this.articles.map( (data) => {
      let results = [];
      data.map( (item) => {
        if ( JSON.stringify(item).toLowerCase().includes(query.value) && this.checkTimestamp(item.timestamp, query.from, query.to) ) {
          item.id = item.$key;
          results.push(item);
        }
      });
      results = take( orderBy( results, ['timestamp'], [query.order || 'desc']), query.limit || results.length);
      return results;
    });
  }

  onLogout() {
    this.subscription.unsubscribe();
    this.af.auth.logout();
  }

  onArticle(articleModel?: any) {

    this.navCtrl.push(Article, { article: articleModel ? articleModel:{ photoURL: '', state: 'draft' }, edit: articleModel ? true:false });

    // let editModal = this.modalCtrl.create(Article, { article: articleModel ? articleModel:{ photoURL: '', state: 'draft' }, edit: articleModel ? true:false });
    // editModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/articles/articles.ts